import axios from 'axios';

import { signIn } from './signIn';

export async function registerNewUser(phone, fName, lName, pass) {
  try {
    const newUser = await axios({
      method: 'POST',
      url: process.env.REACT_APP_API_URL + `/api/users/users/register/`,
      data: {
        is_player: true,
        phone_number: phone,
        first_name: fName,
        last_name: lName,
        password: pass,
      },
    });


    if (newUser.status === 201) {
      const res = await signIn(phone, pass);
    }
    return newUser;
  } catch (error) {
    return { error: error };
  }
}
